import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Typography, Box, Autocomplete } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDatoPersonaNatural, setEstadosCiviles, setPersonaNatural, setSexos
    , setTiposPersona, setOcupaciones, setLugaresTrabajo, setValidations, initPerson, defaultPersonaNatural } from "../redux/personSlice";
import UbigeoSearch from './UbigeoSearch';
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../services/personaService";
import * as catalogoService from "../services/catalogoService";

const PersonaNatural = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(initPerson({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const [openUbigeoSearch, setOpenUbigeoSearch] = useState(false)
    const fechaIngresoMinimo = new Date(2010, 1, 1);
    const fechaNacimientoMaximo = new Date();

    const personaNatural = useSelector((state) => state.person[sliceKey]?.personaNatural);
    const validate = useSelector((state) => state.person[sliceKey]?.validationActive);
    const sexos = useSelector((state) => state.person[sliceKey]?.sexos);
    const estadosCiviles = useSelector((state) => state.person[sliceKey]?.estadosCiviles);
    const tiposPersona = useSelector((state) => state.person[sliceKey]?.tiposPersona);
    const ocupaciones = useSelector((state) => state.person[sliceKey]?.ocupaciones);
    const lugaresTrabajo = useSelector((state) => state.person[sliceKey]?.lugaresTrabajo);

    var validation = {
        primerNombre: {
            error: personaNatural?.primerNombre != null && personaNatural?.primerNombre?.length < 3,
            message: "Falta ingresar el nombre",
        },
        primerApellido: {
            error: personaNatural?.primerApellido != null && personaNatural?.primerApellido?.length < 3,
            message: "Falta ingresar el apellido",
        },
        idSexo: {
            error: personaNatural?.idSexo === 0,
            message: "Falta ingresar el sexo",
        },
        idEstadoCivil: {
            error: personaNatural?.idEstadoCivil === 0,
            message: "Falta ingresar el estado civil",
        },
        idTipoPersona: {
            error: personaNatural?.idTipoPersona === 0,
            message: "Falta ingresar el tipo de persona",
        },
        fechaIngreso: {
            error: Date.parse(personaNatural?.fechaIngreso) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
        fechaNacimiento: {
            error: Date.parse(personaNatural?.fechaNacimiento) > fechaNacimientoMaximo,
            message: "Debe ser una fecha menor a hoy",
        },
    }
    const openCloseUbigeoSearch = () => { setOpenUbigeoSearch(!openUbigeoSearch); }

    const fetchPersonaNatural = async () => {
        const response = await personaService.getPersonaNatural(props.id);
        dispatch(setPersonaNatural({sliceKey: sliceKey, data: response ? response : defaultPersonaNatural}));
    }
    const fetchSexos = async () => {
        const response = await catalogoService.getCatalogosByPadre(32);
        dispatch(setSexos({sliceKey, data: response}));
    }
    const fetchEstadosCiviles = async () => {
        const response = await catalogoService.getCatalogosByPadre(35);
        dispatch(setEstadosCiviles({sliceKey: sliceKey, data: response}));
    }
    const fetchTiposPersona = async () => {
        const response = await catalogoService.getCatalogosByPadre(22);
        dispatch(setTiposPersona({sliceKey: sliceKey, data: response}));
    }
    const fetchOcupaciones = async () => {
        const response = await catalogoService.getCatalogosByPadre(94);
        dispatch(setOcupaciones({sliceKey: sliceKey, data: response}));
    }
    const fetchLugaresTrabajo = async () => {
        const response = await personaService.getLugaresTrabajo();
        dispatch(setLugaresTrabajo({sliceKey: sliceKey, data: response}));
    }

    useEffect(() => {
        fetchPersonaNatural();
        fetchSexos();
        fetchEstadosCiviles();
        fetchTiposPersona();
        fetchOcupaciones();
        fetchLugaresTrabajo();
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, [personaNatural])

    var handleChangePersonaNatural = e => {
        dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }
    const setSelectUbigeoSearch = (selectSearhUbigeo) => {
        console.log(selectSearhUbigeo)
        
        dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "idUbigeoNacimiento", value: parseInt(selectSearhUbigeo.idUbigeo)}))
        dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "ubigeoNacimiento", value: selectSearhUbigeo.descripcion}))
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }
    
    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(personaNatural)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="primerNombre"
                        label="1er Nombre"
                        fullWidth
                        value={personaNatural?.primerNombre || ""}
                        onChange={handleChangePersonaNatural}
                        error={validate?.primerNombre && validation.primerNombre.error}
                        helperText={validate?.primerNombre && validation.primerNombre.error ? validation.primerNombre.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputRef={inputRef}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="segundoNombre"
                        label="2do Nombre"
                        fullWidth
                        value={personaNatural?.segundoNombre || ""}
                        onChange={handleChangePersonaNatural}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="primerApellido"
                        label="1er Apellido"
                        fullWidth
                        value={personaNatural?.primerApellido || ""}
                        onChange={handleChangePersonaNatural}
                        error={validate?.primerApellido && validation.primerApellido.error}
                        helperText={validate?.primerApellido && validation.primerApellido.error ? validation.primerApellido.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="segundoApellido"
                        label="2do Apellido"
                        fullWidth
                        value={personaNatural?.segundoApellido || ""}
                        onChange={handleChangePersonaNatural}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="fechaIngreso"
                        label="Fecha Ingreso"
                        fullWidth
                        type="date"
                        value={moment(personaNatural?.fechaIngreso || moment()).format('yyyy-MM-DD')}
                        onChange={handleChangePersonaNatural}
                        error={validate?.fechaIngreso && validation.fechaIngreso.error}
                        helperText={validate?.fechaIngreso && validation.fechaIngreso.error ? validation.fechaIngreso.message : ""}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}>
                        <InputLabel htmlFor="input-sexo">Sexo</InputLabel>
                        <Select
                            native
                            label="Sexo"
                            value={personaNatural?.idSexo || 0}
                            onChange={handleChangePersonaNatural}
                            inputProps={{
                                name: 'idSexo',
                                id: 'input-sexo',
                            }}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {sexos?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate?.idEstadoCivil && validation.idEstadoCivil.error}>
                        <InputLabel htmlFor="input-estadocivil">Estado Civil</InputLabel>
                        <Select
                            native
                            label="Estado Civil"
                            value={personaNatural?.idEstadoCivil || 0}
                            onChange={handleChangePersonaNatural}
                            inputProps={{
                                name: 'idEstadoCivil',
                                id: 'input-estadocivil',
                            }}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {estadosCiviles?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idEstadoCivil && validation.idEstadoCivil.error ? validation.idEstadoCivil.message : ""}</HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate?.idTipoPersona && validation.idTipoPersona.error}>
                        <InputLabel htmlFor="input-tipopersona">Tipo Persona</InputLabel>
                        <Select
                            native
                            label="Tipo Persona"
                            value={personaNatural?.idTipoPersona || 0}
                            fullWidth
                            onChange={handleChangePersonaNatural}
                            inputProps={{
                                name: 'idTipoPersona',
                                id: 'input-tipopersona',
                            }}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {tiposPersona?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idTipoPersona && validation.idTipoPersona.error ? validation.idTipoPersona.message : ""}</HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="fechaNacimiento"
                        label="Fecha Nac."
                        fullWidth
                        type="date"
                        value={moment(personaNatural?.fechaNacimiento || moment()).format('yyyy-MM-DD')}
                        onChange={handleChangePersonaNatural}
                        error={validate?.fechaNacimiento && validation.fechaNacimiento.error}
                        helperText={validate?.fechaNacimiento && validation.fechaNacimiento.error ? validation.fechaNacimiento.message : ""}
                        size="small"
                    />
                </Grid>
                <Grid item xs={10} sm={3}>
                    <Box display="flex" alignItems="center" gap={0}>
                        <TextField
                            name="ubigeoNacimiento"
                            label="Ubigeo"
                            fullWidth
                            value={personaNatural?.ubigeoNacimiento || ""}
                            onChange={handleChangePersonaNatural}
                            disabled
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <IconButton aria-label="Buscar Ubigeo" size='small' onClick={() => {
                            openCloseUbigeoSearch()
                        }}>
                            <IconSearch />
                        </IconButton>

                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: props.hideInputs ? "none" : "block" }}>
                    <FormControl fullWidth>
                        <Autocomplete
                            name="idOcupacion"
                            value={personaNatural?.idOcupacion || 0}
                            inputValue={personaNatural?.ocupacion || ""}
                            onInputChange={(event, newValue) => {
                                if (event != null) {
                                    if (event.type === "change") {
                                        dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "ocupacion", value: newValue || ""}))
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "idOcupacion", value: newValue?.id || 0}))
                                dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "ocupacion", value: newValue?.descripcion || ""}))
                            }}
                            options={ocupaciones || []}
                            autoHighlight
                            getOptionLabel={(option) => option.descripcion || ""}
                            isOptionEqualToValue ={(option, value) => option.value === value.value}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                    {option.descripcion}
                                    </li>
                                );
                                }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Ocupacion"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                            size="small"
                        />
                        {/* <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: props.hideInputs ? "none" : "block" }}>
                    <FormControl fullWidth>
                        <Autocomplete
                            name="idLugarTrabajo"
                            value={personaNatural?.idLugarTrabajo || 0}
                            inputValue={personaNatural?.lugarTrabajo || ""}
                            onInputChange={(event, newValue) => {
                                if (event != null) {
                                    if (event.type === "change") {
                                        dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "lugarTrabajo", value: newValue || ""}))
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "idLugarTrabajo", value: newValue.id || 0}))
                                dispatch(setDatoPersonaNatural({sliceKey: sliceKey, name: "lugarTrabajo", value: newValue.descripcion || ""}))
                            }}
                            options={lugaresTrabajo || []}
                            autoHighlight
                            getOptionLabel={(option) => option.descripcion || ""}
                            isOptionEqualToValue ={(option, value) => option.value === value.value}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                    {option.descripcion}
                                    </li>
                                );
                                }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Lugar de Trabajo"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                            size="small"
                        />
                        {/* <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
            </Grid>
            <UbigeoSearch open={openUbigeoSearch} openClose={openCloseUbigeoSearch} setSelection={setSelectUbigeoSearch} />
        </Grid>
    );
}
export default PersonaNatural;
